import type { Guide } from '../types';

/** Address, name, search title and description of the guide in each language (menus, cards, links). */
export const mamanguaGuide: Guide = {
  id: 'saco-do-mamangua',
  imageTour: 'saco-de-mamangua-lancha-rapida',
  published: '2026-10-23',
  updated: '2026-10-23',
  tours: [
    'saco-de-mamangua-lancha-rapida',
    'lancha-privada-madame',
    'passeio-de-lancha-privativa-na-baia-de-paraty-20262',
  ],
  copy: {
    pt: {
      slug: 'saco-do-mamangua',
      label: 'Saco do Mamanguá',
      title: 'Saco do Mamanguá: Como Ir, O Que Fazer e Passeio de Lancha',
      description: 'Saco do Mamanguá, o fiorde tropical de Paraty: como chegar, Pico do Pão de Açúcar, praias e vila caiçara. Passeio de lancha saindo de Paraty por {price:saco-de-mamangua-lancha-rapida} por pessoa.',
    },
    es: {
      slug: 'saco-do-mamangua',
      label: 'Saco do Mamanguá',
      title: 'Saco do Mamanguá: Cómo Ir, Qué Hacer y Paseo en Lancha',
      description: 'Saco do Mamanguá, el fiordo tropical de Paraty: cómo llegar, el Pico do Pão de Açúcar, playas y pueblo caiçara. Paseo en lancha desde Paraty por {price:saco-de-mamangua-lancha-rapida} por persona.',
    },
    en: {
      slug: 'saco-do-mamangua',
      label: 'Saco do Mamanguá',
      title: 'Saco do Mamanguá: How to Get There and Speedboat Tour',
      description: 'Saco do Mamanguá, Paraty’s tropical fjord: how to get there, Pico do Pão de Açúcar, beaches and the caiçara village. Speedboat tour from Paraty for {price:saco-de-mamangua-lancha-rapida} per person.',
    },
    fr: {
      slug: 'saco-do-mamangua',
      label: 'Saco do Mamanguá',
      title: 'Saco do Mamanguá : Comment y Aller et Excursion en Vedette',
      description: 'Le Saco do Mamanguá, fjord tropical de Paraty : comment y aller, le Pico do Pão de Açúcar, plages et village caiçara. Excursion en vedette depuis Paraty pour {price:saco-de-mamangua-lancha-rapida} par personne.',
    },
  },
};
